import { useCategories } from "@/context/CategoriesContext";
import { DEFAULT_CATEGORY_NAMES, DEFAULT_CATEGORY_COLORS } from "@/lib/categories";

// kept for any static importer — the live list comes from useCategories()
export const CATEGORIES = DEFAULT_CATEGORY_NAMES;
export const CATEGORY_COLORS = DEFAULT_CATEGORY_COLORS;

export default function CategorySelect({ value, onChange, testPrefix }) {
  const { categories } = useCategories();
  const toggle = (c) => onChange(value.includes(c) ? value.filter((x) => x !== c) : [...value, c]);
  return (
    <div className="sm:col-span-2" data-testid={`${testPrefix}-categories`}>
      <label className="overline-label !text-[10px] block mb-3">Categories — pick all that apply</label>
      <div className="flex flex-wrap gap-2">
        {categories.map((c) => (
          <button
            type="button"
            key={c}
            data-testid={`${testPrefix}-cat-${c.toLowerCase().replace(/[^a-z]+/g, "-")}`}
            onClick={() => toggle(c)}
            className={`font-grotesk text-[10px] uppercase tracking-[0.15em] px-3 py-2 border transition-colors duration-300 ${
              value.includes(c)
                ? "bg-accent border-accent text-accent-foreground"
                : "border-white/20 text-white/60 hover:border-white/60"
            }`}
          >
            {c}
          </button>
        ))}
      </div>
    </div>
  );
}
